import { render } from "./RightSidebar.vue?vue&type=template&id=796de8e4&scoped=true"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"

import "./RightSidebar.vue?vue&type=style&index=0&id=796de8e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796de8e4"]])

export default __exports__